import { render } from "./ListOptionsEmpty.vue?vue&type=template&id=2a2f4cbe"
import script from "./ListOptionsEmpty.vue?vue&type=script&lang=js"
export * from "./ListOptionsEmpty.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__